import { ConfigProvider, Tabs } from 'antd';
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import api from '../../api';
import DateCalendar from './Calendar';
import './index.less';
import RecommendBid from './recommend-bid';
import HighTrafficActivity from './high-traffic-activity';
import classNames from 'classnames';
import { CaretRightOutlined, EllipsisOutlined } from '@ant-design/icons';
import { useDripSource } from '@/apis/dripDataSource';

const prefixCls = 'recommend-activity';
const RecommendActivity = ({ calendarMode, isField = false }) => {
  const [menuList, setMenuList] = useState([]);
  const [activeKey, setActiveKey] = useState('');
  const [defaultMenuOrder, setDefaultMenuOrder] = useState('');
  const [bidActivityInfo, setBidActivityInfo] = useState({});
  // drip数据源
  const [getDripSource] = useDripSource();
  const isGoNewRoomList = getDripSource('useNewOpenApplyVersionInErp', '0') == '1';

  useEffect(() => {
    api.getRecommendActivityMenu({ tab: 0 }).then((data) => {
      const { defaultMenuOrder, menuList = [] } = data.data || {};
      setActiveKey(String(isField ? 1 : defaultMenuOrder));
      setDefaultMenuOrder(String(defaultMenuOrder));
      const filterShowList = menuList.filter((item) => item.show);
      setMenuList(filterShowList);
    });
  }, []);
  const calendarData = useMemo(() => (menuList && menuList ? menuList[0] : {}), [menuList]);
  const JumpUrl = useCallback(() => {
    const currentTab = menuList.find((item) => String(item.order) === activeKey) || {};
    let url = currentTab.jumpUrl ? currentTab.jumpUrl : '';
    let clstagMap = {
      1: 'pageclick|keycount|yx_center|marketingtempo',
      2: 'pageclick|keycount|yx_center|allbiddingsku',
    };
    let title = '查看部门营销节奏表';
    const otherStyle = isField ? { float: 'right', fontSize: 14, fontWeight: 'normal' } : {};
    if (currentTab.order === 2 && Object.keys(bidActivityInfo).length) {
      title = '查看全部竞价商品';
      if (isGoNewRoomList) {
        url = `/platform-marketing/resource-detail/apply-roomList/elpis/intranet/roomlist/biddingEnroll?activityId=${bidActivityInfo.activityId}&areaId=${bidActivityInfo.areaId}&blockId=${bidActivityInfo.areaId}&channelId=${bidActivityInfo.channelId}&entry=1&from=acore&lineType=${bidActivityInfo.lineType}&resourceId=${bidActivityInfo.resourceId}`;
      } else {
        url = `/platform-marketing/resource-detail/material-collection/openArea1/elpis/intranet/biddingEnroll?activityId=${bidActivityInfo.activityId}&areaId=${bidActivityInfo.areaId}&blockId=${bidActivityInfo.areaId}&channelId=${bidActivityInfo.channelId}&entry=1&from=acore&lineType=${bidActivityInfo.lineType}&resourceId=${bidActivityInfo.resourceId}`;
      }
    }
    if (!url) return null;
    return (
      <a
        style={{ color: '#262626', ...otherStyle }}
        clstag={clstagMap[activeKey]}
        target="_blank"
        href={url}
        rel="noreferrer"
      >
        {title}
        <CaretRightOutlined />
      </a>
    );
  }, [menuList, activeKey, isField, bidActivityInfo]);
  useEffect(() => {
    if (
      defaultMenuOrder === '2' &&
      Object.keys(bidActivityInfo).length &&
      !(bidActivityInfo.recommendBidList && bidActivityInfo.recommendBidList.length)
    ) {
      setActiveKey('1');
      // 清除默认值，防止手动点击时被重置
      setDefaultMenuOrder('');
    }
  }, [bidActivityInfo, defaultMenuOrder]);
  const getTabElement = (menu) => {
    const { title, order } = menu;
    const tabContent = (
      <div
        className={classNames({
          'tab-element-icon': true,
          'new-icon': menu.order !== 2 && menu.hotPoint,
          'hot-icon': menu.order === 2 && menu.hotPoint,
        })}
      >
        {title}
      </div>
    );
    return <div>{tabContent}</div> || null;
  };

  const getBidActivityAndAreaId = (info) => {
    setBidActivityInfo(info);
  };

  const renderTabPaneContent = (menu) => {
    const { order } = menu;
    switch (order) {
      case 1:
        return <DateCalendar rangeMode={calendarMode !== 'special'} />;
      case 2:
        return (
          <>
            <RecommendBid mode={calendarMode} getBidActivityAndAreaId={getBidActivityAndAreaId} />
          </>
        );
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
        return (
          <>
            {/* {renderActivityIntroduce(menu, calendarMode === 'special')} */}
            <HighTrafficActivity mode={calendarMode} menuOrder={order} />
          </>
        );
      default:
        return null;
    }
  };

  const handleTabsChange = (key) => {
    setActiveKey(key);
    log && log('yx_center', 'workbench_calendartab', `{"calendartab":"${key >= 3 ? 3 : key}"}`);
  };
  if (!menuList || !menuList.length) {
    return null;
  }
  return (
    <ConfigProvider>
      <div className={prefixCls}>
        <div className="platform-title" style={{ marginBottom: isField ? 12 : 0 }}>
          {isField ? calendarData.title : '推荐活动'}
          {isField && <JumpUrl />}
        </div>
        {isField ? (
          <DateCalendar />
        ) : (
          <Tabs
            activeKey={activeKey}
            onChange={handleTabsChange}
            tabBarExtraContent={<JumpUrl />}
            moreIcon={
              calendarMode === 'special' ? <CaretRightOutlined style={{ color: '#8C8C8C' }} /> : <EllipsisOutlined />
            }
          >
            {menuList.map((menu) => (
              <Tabs.TabPane tab={getTabElement(menu)} key={String(menu.order)}>
                {renderTabPaneContent(menu)}
              </Tabs.TabPane>
            ))}
          </Tabs>
        )}
      </div>
    </ConfigProvider>
  );
};

export default RecommendActivity;
